import { useSelectedFactorBox, useSelectedFactors } from '@/contexts/FactorLensContext/hooks'
import { useIsAnalysisLoading } from '@/contexts/RADashboardDataContext/hooks'
import { useTheme } from '@/contexts/RADashboardThemeContext/hooks'
import { CardProps } from '@/interfaces/raDashboard.interface'
import { cardStyle } from '@/styles/reportDashboardStyles'
import { CircularProgress } from '@mui/material'
import Stack from '@mui/material/Stack'
import React from 'react'
import FactorRiskTable from './FactorRiskTable'

/**
 * Standalone Factor Breakdown card — the factor breakdown ag-grid, split out of
 * FactorLensRisk and wired to the shared FactorLensContext so the selected data
 * type and the pyramid's selected factor box drive the table.
 */
const FactorBreakdownCard: React.FC<CardProps> = (props) => {
  const theme = useTheme()

  const selectedFactorBox = useSelectedFactorBox()
  const factors = useSelectedFactors()

  const dataLoading = useIsAnalysisLoading()

  const cardLoading = () => (
    <div style={{ margin: 5 }}>
      <CircularProgress size={'3rem'} aria-label="Loading…" />
    </div>
  )

  const cardContent = () => (
    <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
      {/* Data type follows the Decomposition card via shared context — no selector here. */}
      {/* Breakdown ag-grid */}
      <div style={{ flex: 1, minHeight: 0, marginTop: 8, border: `1px solid ${theme.border}` }}>
        <FactorRiskTable
          factors={factors}
          selectedFactor={selectedFactorBox}
          loading={false}
          cardPrefs={props.cardPrefs}
          onCardPrefsChange={props.onCardPrefsChange}
        />
      </div>
    </div>
  )

  return (
    <div
      style={{
        ...cardStyle,
        width: '100%',
        height: '100%',
        backgroundColor: theme.cardBackground,
        border: `1px solid ${theme.border}`,
      }}
    >
      <Stack padding={4} width={'100%'} sx={{ boxSizing: 'border-box', height: '100%' }}>
        {/* No card title here — FactorRiskTable renders its own header (title, drill-down hint, search). */}
        {dataLoading ? cardLoading() : cardContent()}
      </Stack>
    </div>
  )
}

export default FactorBreakdownCard
